import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.useConversationStream'

export default defineMessages({
  resumeFailed: {
    id: `${scope}.resumeFailed`,
    defaultMessage:
      "We couldn't reopen this conversation. Please start a new one.",
  },
})
